import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Companies Redux States
import { GET_COMPANY, EDIT_COMPANY } from "./actionTypes";
import { apiError, setCompany, editCompanySuccess } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getCompany() {
  try {
    const response = yield call(axios.get, `/client`);
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setCompany(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* editCompany({ payload: { newCompanyValues } }) {
  try {
    const response = yield call(axios.patch, `/client`, newCompanyValues);
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(editCompanySuccess(newCompanyValues, message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchGetCompany() {
  yield takeEvery(GET_COMPANY, getCompany);
}

export function* watchEditCompany() {
  yield takeEvery(EDIT_COMPANY, editCompany);
}

function* authSaga() {
  yield all([fork(watchGetCompany), fork(watchEditCompany)]);
}

export default authSaga;
